<template>
  <main id="gabung-mitra-page">
    <!-- Background decoration -->
    <div class="bg-decoration">
      <div class="bg-gradient-1"></div>
      <div class="bg-gradient-2"></div>
      <div class="bg-grid"></div>
    </div>

    <section class="mitra-section">
      <div class="mitra-container">
        <!-- Header -->
        <div class="mitra-header">
          <div class="badge-wrapper">
            <span class="badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <line x1="19" y1="8" x2="19" y2="14"/>
                <line x1="22" y1="11" x2="16" y2="11"/>
              </svg>
              Bergabung Sekarang
            </span>
          </div>
          <h1 class="mitra-title">Pendaftaran Mitra <span class="text-gradient">Yohom</span></h1>
          <p class="mitra-subtitle">
            Daftarkan diri Anda sebagai mitra Yohom dan mulai perjalanan bersama kami. Isi formulir di bawah untuk memulai.
          </p>
        </div>

        <!-- Form Card -->
        <div class="form-card">
          <div class="form-card-inner">
            <!-- Form Header inside card -->
            <div class="form-card-header">
              <div class="form-card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10 9 9 9 8 9"/>
                </svg>
              </div>
              <div>
                <h2 class="form-card-title">Data Pendaftaran</h2>
                <p class="form-card-desc">Silakan lengkapi informasi berikut</p>
              </div>
            </div>

            <div class="form-divider"></div>

            <!-- Form Fields -->
            <div class="form-fields">
              <!-- Nama Lengkap -->
              <div class="form-group" :class="{ 'form-group--focused': focused === 'nama', 'form-group--filled': form.nama }">
                <label for="nama" class="form-label">
                  Nama Lengkap
                  <span class="required-dot"></span>
                </label>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <input
                    id="nama"
                    v-model="form.nama"
                    type="text"
                    placeholder="Masukkan nama lengkap Anda"
                    class="form-input"
                    required
                    @focus="focused = 'nama'"
                    @blur="focused = null"
                  />
                </div>
              </div>

              <!-- Nomor Handphone -->
              <div class="form-group" :class="{ 'form-group--focused': focused === 'nohp', 'form-group--filled': form.nohp }">
                <label for="nohp" class="form-label">
                  Nomor Handphone
                  <span class="required-dot"></span>
                </label>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                      <line x1="12" y1="18" x2="12.01" y2="18"/>
                    </svg>
                  </div>
                  <input
                    id="nohp"
                    v-model="form.nohp"
                    :class="{ 'form-input--invalid': validationErrors.no_hp }"
                    :aria-invalid="Boolean(validationErrors.no_hp)"
                    :aria-describedby="validationErrors.no_hp ? 'nohp-error' : null"
                    type="tel"
                    placeholder="Contoh: 08123456789"
                    class="form-input"
                    required
                    @focus="focused = 'nohp'"
                    @blur="focused = null"
                    @input="delete validationErrors.no_hp"
                  />
                </div>
                <p v-if="validationErrors.no_hp" id="nohp-error" class="field-error" role="alert">
                  {{ validationErrors.no_hp.join(' ') }}
                </p>
              </div>

              <!-- Email -->
              <div class="form-group" :class="{ 'form-group--focused': focused === 'email', 'form-group--filled': form.email }">
                <label for="email" class="form-label">
                  Email
                  <span class="required-dot"></span>
                </label>
                <div class="input-wrapper">
                  <div class="input-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                  <input
                    id="email"
                    v-model="form.email"
                    :class="{ 'form-input--invalid': validationErrors.email }"
                    :aria-invalid="Boolean(validationErrors.email)"
                    :aria-describedby="validationErrors.email ? 'email-error' : null"
                    type="email"
                    placeholder="contoh@email.com"
                    class="form-input"
                    required
                    @focus="focused = 'email'"
                    @blur="focused = null"
                    @input="delete validationErrors.email"
                  />
                </div>
                <p v-if="validationErrors.email" id="email-error" class="field-error" role="alert">
                  {{ validationErrors.email.join(' ') }}
                </p>
              </div>

              <!-- Alamat Lengkap -->
              <div class="form-group" :class="{ 'form-group--focused': focused === 'alamat', 'form-group--filled': form.alamat }">
                <label for="alamat" class="form-label">
                  Alamat Lengkap
                  <span class="required-dot"></span>
                </label>
                <div class="input-wrapper input-wrapper--textarea">
                  <div class="input-icon input-icon--textarea">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                  </div>
                  <textarea
                    id="alamat"
                    v-model="form.alamat"
                    class="form-input form-textarea"
                    placeholder="Masukkan alamat lengkap Anda"
                    rows="4"
                    required
                    @focus="focused = 'alamat'"
                    @blur="focused = null"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="form-divider"></div>

            <!-- Submit Area -->
            <div class="form-actions">
              <p class="form-disclaimer">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="16" x2="12" y2="12"/>
                  <line x1="12" y1="8" x2="12.01" y2="8"/>
                </svg>
                Pastikan data yang Anda masukkan sudah benar
              </p>
              <button
                @click="upload"
                class="btn-submit"
                :class="{ 'btn-submit--loading': isLoading }"
                :disabled="isLoading"
              >
                <span v-if="!isLoading" class="btn-content">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  Daftar Sekarang
                </span>
                <span v-else class="btn-content">
                  <span class="spinner"></span>
                  Memproses...
                </span>
              </button>
            </div>
          </div>
        </div>

        <!-- Bottom info -->
        <div class="bottom-info">
          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>Data Anda terlindungi</span>
          </div>
          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <span>Proses cepat & mudah</span>
          </div>
          <div class="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span>Verifikasi transparan</span>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "GabungMitra",
  data() {
    return {
      form: {
        nama: null,
        alamat: null,
        nohp: null,
        email: null,
      },
      config: {
        headers: {
          api_key: "yohom_12345",
          Accept: "application/json",
        },
      },
      focused: null,
      isLoading: false,
      validationErrors: {},
    };
  },
  components: {},
  methods: {
    showApiError(data) {
      const errors = data && data.errors;
      this.validationErrors = {};
      if (errors && typeof errors === "object") {
        Object.keys(errors).forEach((field) => {
          const messages = Array.isArray(errors[field]) ? errors[field] : [errors[field]];
          const validMessages = messages.filter((message) => typeof message === "string" && message.trim());
          if (validMessages.length) {
            this.validationErrors[field] = validMessages;
          }
        });
      }
      const messages = Object.values(this.validationErrors).flat();
      const message = messages.length
        ? messages.join(" ")
        : (data && typeof data.message === "string" && data.message.trim()) ||
          "Terjadi kesalahan saat mengirim data. Silakan coba lagi.";
      return this.showError(message);
    },
    showError(msg) {
      return this.$swal({
        title: "Peringatan",
        text: msg,
        icon: "error",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Kembali",
        customClass: { popup: 'swal-public-sans' },
      });
    },
    showSuccess(msg) {
      return this.$swal({
        title: "Informasi",
        text: msg,
        icon: "success",
        confirmButtonColor: "#00d16c",
        confirmButtonText: "Kembali",
        customClass: { popup: 'swal-public-sans' },
      }).then(() => {
        window.location.reload();
      });
    },
    async upload() {
      if (this.isLoading) return;

      // Validation
      if (!this.form.nama || !this.form.nohp || !this.form.email || !this.form.alamat) {
        this.showError("Mohon lengkapi semua data yang diperlukan");
        return;
      }

      this.isLoading = true;
      this.validationErrors = {};

      var form = new FormData();
      form.append("nama", this.form.nama);
      form.append("no_hp", this.form.nohp);
      form.append("email", this.form.email);
      form.append("alamat", this.form.alamat);

      await axios
        .post("https://admincp.yohom.co.id/api/mitra/store-new", form, this.config)
        .then((res) => {
          if (!res.data || res.data.status !== true) {
            this.showApiError(res.data);
            return;
          }
          this.showSuccess(
            "Pengajuan Anda sebagai Mitra Berhasil di simpan Mohon Tunggu Informasi dari kami terkait penerimaan mitra."
          );
        })
        .catch((err) => {
          this.showApiError(err.response && err.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
/* ============================
   Import Public Sans Font
   ============================ */
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap');

/* ============================
   Page Wrapper
   ============================ */
#gabung-mitra-page {
  font-family: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  min-height: 100vh;
  background-color: #fcfcfd;
  position: relative;
  overflow: hidden;
  padding: 80px 16px 60px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ============================
   Background Decoration
   ============================ */
.bg-decoration {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.bg-gradient-1 {
  position: absolute;
  top: -200px;
  right: -100px;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(16, 185, 129, 0.08) 0%, transparent 70%);
  animation: float 8s ease-in-out infinite;
}

.bg-gradient-2 {
  position: absolute;
  bottom: -150px;
  left: -100px;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.06) 0%, transparent 70%);
  animation: float 10s ease-in-out infinite reverse;
}

.bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 0, 0, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 100%);
}

@keyframes float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-30px) scale(1.05); }
}

/* ============================
   Section & Container
   ============================ */
.mitra-section {
  position: relative;
  z-index: 1;
}

.mitra-container {
  max-width: 640px;
  margin: 0 auto;
}

/* ============================
   Header
   ============================ */
.mitra-header {
  text-align: center;
  margin-bottom: 40px;
}

.badge-wrapper {
  margin-bottom: 20px;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 100px;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(16, 185, 129, 0.15);
  transition: all 0.2s ease;
}

.badge:hover {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.25);
}

.mitra-title {
  font-size: 36px;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  letter-spacing: -0.025em;
  margin: 0 0 12px;
}

.text-gradient {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.mitra-subtitle {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  max-width: 480px;
  margin: 0 auto;
  font-weight: 400;
}

/* ============================
   Form Card
   ============================ */
.form-card {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.03),
    0 1px 6px -1px rgba(0, 0, 0, 0.02),
    0 2px 4px 0 rgba(0, 0, 0, 0.02);
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
  overflow: hidden;
}

.form-card:hover {
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -2px rgba(0, 0, 0, 0.03),
    0 0 0 1px rgba(16, 185, 129, 0.05);
}

.form-card-inner {
  padding: 32px;
}

/* Card Header */
.form-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.form-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);
  color: #059669;
  flex-shrink: 0;
}

.form-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 2px;
  letter-spacing: -0.01em;
}

.form-card-desc {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
  font-weight: 400;
}

/* Divider */
.form-divider {
  height: 1px;
  background: #f3f4f6;
  margin: 24px 0;
}

/* ============================
   Form Fields
   ============================ */
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  position: relative;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  letter-spacing: -0.006em;
}

.required-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
  flex-shrink: 0;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper--textarea {
  align-items: flex-start;
}

.input-icon {
  position: absolute;
  left: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  transition: color 0.2s ease;
  z-index: 1;
}

.input-icon--textarea {
  top: 14px;
}

.form-group--focused .input-icon {
  color: #10b981;
}

.form-input {
  width: 100%;
  padding: 11px 14px 11px 44px;
  font-size: 15px;
  font-family: 'Public Sans', sans-serif;
  font-weight: 400;
  color: #111827;
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  outline: none;
  transition: all 0.2s ease;
  line-height: 1.5;
}

.form-input::placeholder {
  color: #c3c7ce;
  font-weight: 400;
}

.form-input:hover {
  border-color: #d1d5db;
  background: #f3f4f6;
}

.form-input:focus {
  border-color: #10b981;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.form-input--invalid,
.form-input--invalid:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.field-error {
  margin: 6px 0 0;
  color: #dc2626;
  font-size: 13px;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

/* ============================
   Form Actions
   ============================ */
.form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.form-disclaimer {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
  font-weight: 400;
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  font-family: 'Public Sans', sans-serif;
  color: #ffffff;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-submit::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-submit:hover:not(:disabled)::before {
  opacity: 1;
}

.btn-submit:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(16, 185, 129, 0.2);
}

.btn-submit--loading {
  opacity: 0.8;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Spinner */
.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ============================
   Bottom Info
   ============================ */
.bottom-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}

.info-item svg {
  color: #d1d5db;
  flex-shrink: 0;
}

/* ============================
   Responsive
   ============================ */
@media (max-width: 640px) {
  #gabung-mitra-page {
    padding: 60px 16px 40px;
  }

  .mitra-title {
    font-size: 28px;
  }

  .mitra-subtitle {
    font-size: 15px;
  }

  .form-card-inner {
    padding: 24px 20px;
  }

  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .form-disclaimer {
    justify-content: center;
    order: 2;
  }

  .btn-submit {
    width: 100%;
    justify-content: center;
    order: 1;
  }

  .bottom-info {
    flex-direction: column;
    gap: 12px;
  }
}
</style>

<!-- Global override: SweetAlert2 berada di luar scoped CSS, butuh style tanpa scoped -->
<style>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700&display=swap');

.swal-public-sans,
.swal-public-sans .swal2-title,
.swal-public-sans .swal2-html-container,
.swal-public-sans .swal2-content,
.swal-public-sans .swal2-confirm,
.swal-public-sans .swal2-cancel,
.swal-public-sans .swal2-deny {
  font-family: 'Public Sans', sans-serif !important;
  -webkit-font-smoothing: antialiased;
}

.swal-public-sans .swal2-title {
  font-weight: 700;
  font-size: 20px;
  letter-spacing: -0.015em;
}

.swal-public-sans .swal2-html-container,
.swal-public-sans .swal2-content {
  font-weight: 400;
  font-size: 15px;
  color: #6b7280;
}

.swal-public-sans .swal2-confirm,
.swal-public-sans .swal2-cancel {
  font-weight: 600;
  font-size: 14px;
  border-radius: 8px !important;
  padding: 10px 24px !important;
}
</style>
